// eslint-disable-next-line import/no-cycle
import { APIS, clients } from '@/core/clients';

const client = clients[APIS.SELF_SERVICE.name];
const storageApi = {
  getFileNames(campaignId, payload) {
    return client.get(`/storage/campaigns/${campaignId}/files?bucket=${payload.bucket}&folder=${payload.folder}`)
      .then((response) => response.data);
  },
  getFile(campaignId, payload) {
    return client.get(`/storage/campaigns/${campaignId}/file?bucket=${payload.bucket}&fileName=${payload.fileName}&folder=${payload.folder}`)
      .then((response) => response.data);
  },
  deleteFile(campaignId, payload) {
    return client.delete(`/storage/campaigns/${campaignId}/file?bucket=${payload.bucket}&fileName=${payload.fileName}&folder=${payload.folder}`)
      .then((response) => response.data);
  },
};
export default storageApi;
